module.exports = __webpack_public_path__ + "static/media/story-31.1a1322fb.jpg";